import PythonApi from "../services/PythonApi";

export default {
  get(id) {
    const url = "buildings/" + id;
    return PythonApi().get(url);
  },
  list() {
    const url = "buildings";
    return PythonApi().get(url);
  },
  put(id, payload) {
    const url = "buildings/" + id;
    return PythonApi().put(url, payload)
  },
  post(payload) {
    const url = "buildings";
    return PythonApi().post(url, payload);
  },
  delete(id) {
    const url = "buildings/" + id;
    return PythonApi().delete(url);
  }
};



// WEBPACK FOOTER //
// ./src/api/buildings-api.js